import { Getters } from './types'

const getters: Getters = {
  posts: (state) => state.posts || [],
  postsLength: (state) => state.posts?.length ?? null,
}

export default getters
